'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var isReactNative = typeof window !== 'undefined' && window.navigator && window.navigator.product && window.navigator.product === 'ReactNative';

exports.default = isReactNative;


/*****************
 ** WEBPACK FOOTER
 ** ./~/redux-form/lib/isReactNative.js
 ** module id = 746
 ** module chunks = 0
 **/